import React, { useEffect, useState } from 'react';
import { areasAPI } from '../../utils/api';
import '../../pages/Area/Area.css';
import './CreateAreaModal.css';

interface Props {
  onClose: () => void;
  onCreated: (area: { id: number; name: string }) => void;
}

export default function CreateAreaModal({ onClose, onCreated }: Props) {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const handleKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && !busy) { event.stopImmediatePropagation(); onClose(); }
    };
    document.addEventListener('keydown', handleKey, true);
    return () => document.removeEventListener('keydown', handleKey, true);
  }, [busy, onClose]);

  return <div className="area-modal" style={{ zIndex: 1100 }} role="dialog" aria-modal="true" aria-labelledby="create-area-title">
    <div className="area-modal__backdrop" onClick={() => !busy && onClose()} />
    <div className="area-modal__dialog create-area-modal__dialog">
      <header className="area-modal__header">
        <h2 id="create-area-title" className="area-modal__title">Создать участок</h2>
        <button type="button" className="area-modal__close" aria-label="Закрыть" disabled={busy} onClick={onClose}>×</button>
      </header>
      <form className="area-modal__body create-area-modal__form" onSubmit={async (event) => {
        event.preventDefault();
        if (busy || !name.trim()) return;
        setBusy(true); setError('');
        try {
          const response = await areasAPI.create(name.trim(), description.trim() || undefined);
          if (!response.success || !response.area) throw new Error(response.message || 'Не удалось создать участок');
          onCreated(response.area);
        } catch (err) { setError((err as Error).message || 'Не удалось создать участок'); }
        finally { setBusy(false); }
      }}>
        <div className="create-area-modal__fields">
          <label className="area-modal__field">Название участка
            <input autoFocus className="area-modal__input" placeholder="Например, Склад №1" maxLength={255} required value={name} disabled={busy} onChange={(event) => setName(event.target.value)} />
          </label>
          <label className="area-modal__field">Описание
            <input className="area-modal__input" placeholder="Необязательно" maxLength={1000} value={description} disabled={busy} onChange={(event) => setDescription(event.target.value)} />
          </label>
          {error && <p role="alert" style={{ color: 'hsl(var(--destructive))' }}>{error}</p>}
        </div>
        <footer className="area-modal__footer create-area-modal__footer">
          <button type="button" className="area-modal__submit area-modal__submit--secondary" disabled={busy} onClick={onClose}>Отмена</button>
          <button type="submit" className="area-modal__submit" disabled={busy || !name.trim()}>{busy ? 'Создание…' : 'Создать участок'}</button>
        </footer>
      </form>
    </div>
  </div>;
}
